import { render } from "./collapse.vue?vue&type=template&id=348ed12e&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=348ed12e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-348ed12e"

export default script